import React, { useState, useEffect } from 'react';
import { Plus, Bot, Search, Copy, Settings, Users, MessageSquare, DollarSign, Edit, Trash2, AlertCircle, Zap, RefreshCw } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import { API_URL } from '../../config';
import ManyChatBotConfig from './ManyChatBotConfig';

export default function ManyChatPagesManagement() {
  const [pages, setPages] = useState([]);
  const [configs, setConfigs] = useState([]);
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);
  const [newPage, setNewPage] = useState({
    name: '',
    facebook_page_name: '',
    facebook_page_id: '',
    facebook_page_url: '',
    webhook_slug: '',
    page_access_token: ''
  });

  const [globalStats, setGlobalStats] = useState({
    total_pages: 0,
    active_bots: 0,
    total_clients: 0,
    max_clients: 500,
    total_messages: 0,
    total_cost: 0,
    total_tokens: 0
  });

  useEffect(() => {
    console.log("🔄 Montage composant");
    loadAllData();
  }, []);
  
  const loadAllData = async () => {
    console.log("📦 Chargement complet");
    setLoading(true);
    
    const pagesData = await loadPages();
    const configsData = await loadConfigs();
    
    console.log(`✅ ${pagesData.length} pages, ${configsData.length} configs`);
    
    setTimeout(async () => {
      await loadGlobalStats();
      setLoading(false);
    }, 500);
  };

  const loadData = async () => {
    setLoading(true);
    await Promise.all([
      loadPages(),
      loadConfigs(),
    ]);
    setLoading(false);
  };


  const loadPages = async () => {
    try {
      const response = await fetch(`${API_URL}/api/clients`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setPages(data.clients || []);
        return data.clients || [];  // ← AJOUTE ÇA
      }
    } catch (error) {
      console.error('Error loading pages:', error);
    }
    return [];  // ← AJOUTE ÇA
  };

  const loadConfigs = async () => {
    try {
      const response = await fetch(`${API_URL}/api/admin/messenger-configs`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setConfigs(data.configs || []);
        return data.configs || [];  // ← AJOUTE ÇA
      }
    } catch (error) {
      console.error('Error loading configs:', error);
    }
    return [];  // ← AJOUTE ÇA
  };

  const loadGlobalStats = async () => {
    try {
      console.log("\n🔄 ===== CHARGEMENT STATS (OPTIMISÉ) =====");
      
      let currentPages = pages.length > 0 ? pages : await loadPages();
      let currentConfigs = configs.length > 0 ? configs : await loadConfigs();
      
      if (currentPages.length === 0) {
        console.log("❌ Aucune page");
        return;
      }
      
      console.log(`📊 Chargement stats pour ${currentPages.length} pages EN 1 APPEL`);
      
      // ✅ 1 SEUL APPEL API pour toutes les pages
      const response = await fetch(`${API_URL}/api/admin/all-messenger-stats`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
      });
      
      if (!response.ok) {
        console.error('❌ Erreur chargement stats');
        return;
      }
      
      const data = await response.json();
      const statsByClient = data.stats_by_client || {};
      
      console.log('✅ Stats reçues:', Object.keys(statsByClient).length, 'clients');
      
      // Associer stats aux pages
      const pagesWithStats = currentPages.map(page => {
        const pageStats = statsByClient[page.$id] || {
          total_conversations: 0,
          active_conversations: 0,
          total_messages: 0,
          user_messages: 0,
          bot_responses: 0,
          unique_clients: 0,
          total_cost_usd: 0,
          total_tokens: 0,
          llm_calls: 0,
          avg_cost_per_call: 0
        };
        
        console.log(`   ${page.facebook_page_name}:`, {
          clients: pageStats.unique_clients,
          messages: pageStats.total_messages,
          cost: pageStats.total_cost_usd
        });
        
        return {
          page_id: page.$id,
          page_name: page.facebook_page_name,
          ...pageStats
        };
      });
      
      // Calcul sommes globales
      const total_messages = pagesWithStats.reduce((sum, stat) => sum + (stat.total_messages || 0), 0);
      const total_clients = pagesWithStats.reduce((sum, stat) => sum + (stat.unique_clients || 0), 0);
      const total_cost = pagesWithStats.reduce((sum, stat) => sum + (stat.total_cost_usd || 0), 0);
      const total_tokens = pagesWithStats.reduce((sum, stat) => sum + (stat.total_tokens || 0), 0);
      const active_bots = currentConfigs.filter(c => c.is_active === true || c.is_active === 1).length;
      const max_clients = currentPages.length * 500;
      
      const newGlobalStats = {
        total_pages: currentPages.length,
        active_bots,
        total_clients,
        max_clients,
        total_messages,
        total_cost,
        total_tokens
      };
      
      console.log("\n✅ STATS GLOBALES:", newGlobalStats);
      console.log("========================================\n");
      
      setGlobalStats(newGlobalStats);
      setStats(pagesWithStats);
      
    } catch (error) {
      console.error('❌ Erreur loading global stats:', error);
    }
  };

  const createPage = async (e) => {
    e.preventDefault();
    
    if (!newPage.webhook_slug) {
      toast.error('Webhook slug requis');
      return;
    }

    toast.loading('Création...', { id: 'create' });
    
    try {
      const response = await fetch(`${API_URL}/api/clients`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          ...newPage,
          owner_user_id: localStorage.getItem('user_id'),
          status: 'active'
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success('Page créée !', { id: 'create' });
        setShowCreateModal(false);
        setNewPage({
          name: '',
          facebook_page_name: '',
          facebook_page_id: '',
          facebook_page_url: '',
          webhook_slug: '',
          page_access_token: ''
        });
        loadData();
      } else {
        toast.error(data.message || 'Erreur', { id: 'create' });
      }
    } catch (error) {
      toast.error('Erreur réseau', { id: 'create' });
    }
  };

  const deletePage = async (pageId, pageName) => {
    if (!window.confirm(`Supprimer "${pageName}" ?`)) return;
    
    toast.loading('Suppression...', { id: 'delete' });
    
    try {
      const response = await fetch(`${API_URL}/api/clients/${pageId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }
      });
      
      if (response.ok) {
        toast.success('Page supprimée', { id: 'delete' });
        loadData();
      } else {
        const data = await response.json();
        toast.error(data.message || 'Erreur', { id: 'delete' });
      }
    } catch (error) {
      toast.error('Erreur réseau', { id: 'delete' });
    }
  };

  const getPageConfig = (pageId) => configs.find(c => c.client_id === pageId);
  const getPageStats = (pageId) => stats.find(s => s.page_id === pageId) || {};

  const copyWebhook = (slug) => {
    const url = `${API_URL}/webhook/manychat/${slug}`;
    navigator.clipboard.writeText(url);
    toast.success('Webhook copié !');
  };

  const generateSlug = (pageName) => {
    return pageName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  };

  const filteredPages = pages.filter(page => 
    page.facebook_page_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    page.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-4 md:space-y-6">
      <Toaster position="top-right" />
      
      {/* Header - Responsive */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 flex items-center gap-3">
            <Bot className="w-6 h-6 md:w-8 md:h-8 text-green-400" />
            ManyChat Pages
          </h2>
          <p className="text-sm md:text-base text-blue-200">Multi-webhook avec stats temps réel</p>
        </div>

        <button
            onClick={async () => {
                setLoading(true);
                await loadGlobalStats();
                setLoading(false);
                toast.success('Stats actualisées !');
            }}
            className="flex items-center gap-2 px-4 py-3 bg-blue-500/20 hover:bg-blue-500/30 rounded-xl text-blue-300"
            >
            <RefreshCw className="w-5 h-5" />
            <span className="hidden md:inline">Actualiser</span>
            </button>

        <button
          onClick={() => setShowCreateModal(true)}
          className="flex items-center justify-center gap-2 px-4 md:px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 rounded-xl text-white font-bold transition-all shadow-lg hover:scale-105 w-full md:w-auto"
        >
          <Plus className="w-5 h-5" />
          Nouvelle Page
        </button>
      </div>

      {/* Stats Globales - Responsive Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6">
        <div className="bg-gradient-to-br from-blue-600 to-cyan-600 rounded-xl md:rounded-2xl p-4 md:p-6 text-white">
          <div className="flex items-center justify-between mb-2 md:mb-4">
            <Bot className="w-8 h-8 md:w-10 md:h-10 opacity-80" />
            <div className="text-2xl md:text-4xl font-bold">{globalStats.total_pages}</div>
          </div>
          <h3 className="text-sm md:text-lg font-semibold">Pages</h3>
          <p className="text-white/80 text-xs md:text-sm">{globalStats.active_bots} bots actifs</p>
        </div>

        <div className="bg-gradient-to-br from-green-600 to-emerald-600 rounded-xl md:rounded-2xl p-4 md:p-6 text-white">
          <div className="flex items-center justify-between mb-2 md:mb-4">
            <Users className="w-8 h-8 md:w-10 md:h-10 opacity-80" />
            <div className="text-2xl md:text-4xl font-bold">{globalStats.total_clients}</div>
          </div>
          <h3 className="text-sm md:text-lg font-semibold">Clients</h3>
          <p className="text-white/80 text-xs md:text-sm">Sur {globalStats.max_clients} max</p>
          <div className="mt-2 h-1.5 md:h-2 bg-white/20 rounded-full overflow-hidden">
            <div 
              className="h-full bg-white rounded-full transition-all"
              style={{ width: `${Math.min((globalStats.total_clients / globalStats.max_clients) * 100, 100)}%` }}
            />
          </div>
        </div>

        <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-xl md:rounded-2xl p-4 md:p-6 text-white">
          <div className="flex items-center justify-between mb-2 md:mb-4">
            <MessageSquare className="w-8 h-8 md:w-10 md:h-10 opacity-80" />
            <div className="text-2xl md:text-4xl font-bold">{globalStats.total_messages}</div>
          </div>
          <h3 className="text-sm md:text-lg font-semibold">Messages</h3>
          <p className="text-white/80 text-xs md:text-sm">Tous bots</p>
        </div>

        <div className="bg-gradient-to-br from-orange-600 to-red-600 rounded-xl md:rounded-2xl p-4 md:p-6 text-white">
          <div className="flex items-center justify-between mb-2 md:mb-4">
            <DollarSign className="w-8 h-8 md:w-10 md:h-10 opacity-80" />
            <div className="text-2xl md:text-4xl font-bold">
              ${globalStats.total_cost.toFixed(6)}
            </div>
          </div>
          <h3 className="text-sm md:text-lg font-semibold">Coût LLM Total</h3>
          <p className="text-white/80 text-xs md:text-sm">
            • {globalStats.total_tokens.toLocaleString()} tok
          </p>
        </div>
      </div>

      {/* Recherche - Responsive */}
      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/40" />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Rechercher..."
          className="w-full bg-white/5 border border-white/10 rounded-xl pl-12 pr-4 py-3 text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      {/* Liste Pages - Responsive Grid */}
      {loading ? (
        <div className="text-center py-12">
          <Bot className="w-12 h-12 text-green-400 animate-spin mx-auto mb-4" />
          <p className="text-white/60">Chargement...</p>
        </div>
      ) : filteredPages.length === 0 ? (
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 md:p-12 text-center">
          <Bot className="w-12 h-12 md:w-16 md:h-16 text-white/40 mx-auto mb-4" />
          <p className="text-white/60">Aucune page trouvée</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
          {filteredPages.map((page) => {
            const config = getPageConfig(page.$id);
            const pageStats = getPageStats(page.$id);
            const isActive = config?.is_active || false;
            const webhookUrl = `${API_URL}/webhook/manychat/${page.webhook_slug || page.facebook_page_id}`;

            return (
              <div 
                key={page.$id}
                className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-xl md:rounded-2xl p-4 md:p-6 hover:border-green-500/50 transition-all"
              >
                {/* Header - Responsive */}
                <div className="flex items-start justify-between mb-4 gap-3">
                  <div className="flex items-start gap-3 flex-1 min-w-0">
                    <div className={`w-12 h-12 md:w-16 md:h-16 rounded-xl flex items-center justify-center flex-shrink-0 ${
                      isActive 
                        ? 'bg-gradient-to-br from-green-500 to-emerald-500' 
                        : 'bg-gradient-to-br from-gray-600 to-gray-700'
                    }`}>
                      <Bot className="w-6 h-6 md:w-8 md:h-8 text-white" />
                    </div>
                    
                    <div className="flex-1 min-w-0">
                      <h3 className="text-lg md:text-xl font-bold text-white mb-1 truncate">
                        {page.facebook_page_name}
                      </h3>
                      <p className="text-xs md:text-sm text-blue-200 mb-2 truncate">{page.name}</p>
                      
                      <div className={`inline-flex items-center gap-2 px-2 md:px-3 py-1 rounded-full text-xs md:text-sm ${
                        isActive
                          ? 'bg-green-500/20 text-green-300 border border-green-500/30'
                          : 'bg-gray-500/20 text-gray-300 border border-gray-500/30'
                      }`}>
                        <div className={`w-2 h-2 rounded-full ${isActive ? 'bg-green-400 animate-pulse' : 'bg-gray-400'}`} />
                        {isActive ? 'Actif' : 'Inactif'}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 flex-shrink-0">
                    <button
                      onClick={() => {
                        setSelectedPage(page);
                        setShowConfigModal(true);
                      }}
                      className="p-2 bg-blue-500/20 hover:bg-blue-500/30 rounded-lg text-blue-300 transition-all"
                    >
                      <Settings className="w-4 h-4 md:w-5 md:h-5" />
                    </button>
                    <button
                      onClick={() => deletePage(page.$id, page.facebook_page_name)}
                      className="p-2 bg-red-500/20 hover:bg-red-500/30 rounded-lg text-red-300 transition-all"
                    >
                      <Trash2 className="w-4 h-4 md:w-5 md:h-5" />
                    </button>
                  </div>
                </div>

                {/* Webhook URL - Responsive */}
                <div className="bg-green-500/10 border border-green-500/20 rounded-lg md:rounded-xl p-3 md:p-4 mb-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-green-300 text-xs md:text-sm font-semibold">Webhook ManyChat</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <code className="text-white font-mono text-xs flex-1 break-all">
                      {webhookUrl}
                    </code>
                    <button
                      onClick={() => copyWebhook(page.webhook_slug || page.facebook_page_id)}
                      className="p-2 bg-green-500/20 hover:bg-green-500/30 rounded-lg transition-all flex-shrink-0"
                    >
                      <Copy className="w-4 h-4 text-green-300" />
                    </button>
                  </div>
                </div>

                {/* Stats - Responsive Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
                  <div className="bg-white/5 rounded-lg md:rounded-xl p-2 md:p-3">
                    <div className="text-xs text-white/60 mb-1">Clients</div>
                    <div className="text-lg md:text-2xl font-bold text-white">
                      {pageStats.unique_clients || 0}
                    </div>
                    <div className="text-xs text-green-300">/500</div>
                  </div>

                  <div className="bg-white/5 rounded-lg md:rounded-xl p-2 md:p-3">
                    <div className="text-xs text-white/60 mb-1">Messages</div>
                    <div className="text-lg md:text-2xl font-bold text-white">
                      {pageStats.total_messages || 0}
                    </div>
                  </div>

                  <div className="bg-white/5 rounded-lg md:rounded-xl p-2 md:p-3">
                    <div className="text-xs text-white/60 mb-1">Appels LLM</div>
                    <div className="text-lg md:text-2xl font-bold text-white">
                      {pageStats.llm_calls || 0}
                    </div>
                    <div className="text-xs text-purple-300">
                      {(pageStats.total_tokens || 0).toLocaleString()} tok
                    </div>
                  </div>

                  <div className="bg-white/5 rounded-lg md:rounded-xl p-2 md:p-3">
                    <div className="text-xs text-white/60 mb-1">Coût LLM</div>
                    <div className="text-lg md:text-2xl font-bold text-white">
                      ${(pageStats.total_cost_usd || 0).toFixed(6)}
                    </div>
                  </div>
                </div>

                {/* Actions - Responsive */}
                <div className="mt-4 flex gap-2">
                  <button
                    onClick={() => {
                      setSelectedPage(page);
                      setShowConfigModal(true);
                    }}
                    className="flex-1 flex items-center justify-center gap-2 px-3 md:px-4 py-2 bg-blue-500/20 hover:bg-blue-500/30 rounded-lg text-blue-300 transition-all text-sm md:text-base"
                  >
                    <Settings className="w-4 h-4" />
                    <span className="hidden sm:inline">Configurer</span>
                    <span className="sm:hidden">Config</span>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal Création - (reste identique) */}
      {showCreateModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-slate-900 border border-white/20 rounded-2xl p-6 md:p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-6">Nouvelle Page ManyChat</h3>
            
            <form onSubmit={createPage} className="space-y-4">
              <div>
                <label className="block text-blue-200 text-sm font-medium mb-2">
                  Nom de la page *
                </label>
                <input
                  type="text"
                  value={newPage.facebook_page_name}
                  onChange={(e) => {
                    const name = e.target.value;
                    setNewPage({
                      ...newPage, 
                      facebook_page_name: name,
                      name: name,
                      webhook_slug: generateSlug(name)
                    });
                  }}
                  className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="Restaurant Tana"
                  required
                />
              </div>

              <div>
                <label className="block text-blue-200 text-sm font-medium mb-2">
                  Webhook Slug (auto-généré) *
                </label>
                <input
                  type="text"
                  value={newPage.webhook_slug}
                  onChange={(e) => setNewPage({...newPage, webhook_slug: e.target.value})}
                  className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white font-mono focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="restaurant-tana"
                  required
                />
                <p className="text-xs text-green-300 mt-1">
                  URL: {API_URL}/webhook/manychat/{newPage.webhook_slug || 'votre-slug'}
                </p>
              </div>

              <div>
                <label className="block text-blue-200 text-sm font-medium mb-2">
                  Page ID Facebook *
                </label>
                <input
                  type="text"
                  value={newPage.facebook_page_id}
                  onChange={(e) => setNewPage({...newPage, facebook_page_id: e.target.value})}
                  className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white font-mono focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="123456789012345"
                  required
                />
              </div>

              <div>
                <label className="block text-blue-200 text-sm font-medium mb-2">
                  URL de la page
                </label>
                <input
                  type="url"
                  value={newPage.facebook_page_url}
                  onChange={(e) => setNewPage({...newPage, facebook_page_url: e.target.value})}
                  className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="https://facebook.com/restaurant-tana"
                />
              </div>

              <div className="bg-green-500/10 border border-green-500/20 rounded-xl p-4">
                <h4 className="text-green-300 font-semibold mb-2 flex items-center gap-2">
                  <AlertCircle className="w-4 h-4" />
                  Configuration ManyChat
                </h4>
                <ol className="text-sm text-green-200 space-y-1 list-decimal list-inside">
                  <li>Copiez le webhook URL généré ci-dessus</li>
                  <li>Allez dans ManyChat → Settings → Growth Tools</li>
                  <li>Collez l'URL dans le webhook</li>
                  <li>Testez la connexion</li>
                </ol>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowCreateModal(false)}
                  className="flex-1 px-4 py-3 bg-white/10 hover:bg-white/20 rounded-xl text-white transition-all"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-3 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 rounded-xl text-white font-bold transition-all"
                >
                  Créer la Page
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Config Bot */}
      {showConfigModal && selectedPage && (
        <ManyChatBotConfig 
          page={selectedPage}
          onClose={() => {
            setShowConfigModal(false);
            setSelectedPage(null);
            loadData();
          }}
        />
      )}
    </div>
  );
}